// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"213":"ee2cf8c6","732":"f148c119"}[chunkId] + ".chunk.js");